import http from "./HttpService";

const apiEndPoint = "/anwender";

export function register(user) {
    return http.post(apiEndPoint + "/register/", {...user});
}

export const getAnwenderListEndpoint = apiEndPoint + "/";

export const getAnwenderMe = apiEndPoint + "/me/";

export const getPersonEndpoint = (betriebsId) => "/person/" + betriebsId;

export const getPersonByLokaleRolleConnectedToBetriebEndpoint = (betriebsId) => "/person/lokaleRolle/" + betriebsId;

export const getZustSBSEndpoint = "/person/zustSBS/";

export const putAnwenderProfile = apiEndPoint + "/profile/";

export const personalisierungEndpoint = apiEndPoint + "/personalisierung/";

export const activatePersonalisierungEndpoint = personalisierungEndpoint + "active";

export const deactivatePersonalisierungEndpoint = personalisierungEndpoint + "inactive";

export function postAnwenderExportEndpointConfiguration(selectedIds) {
    return {
        url: apiEndPoint + "/export/",
        method: "POST",
        data: selectedIds,
        responseType: "blob",
    };
}

export function getSendPasswordResetMailEndpoint() {
    return apiEndPoint + "/sendPasswordResetMail/";
}

export function getResetPasswordEndpoint() {
    return apiEndPoint + "/resetPassword/";
}